import {reactFetchJSON} from '@github-ui/verified-fetch'
import type {DeferredItem} from '@github-ui/shared-dashboard-lists/pulls/types/list-types'
import type {PullsInboxDeferredDataPayload} from '../types/routes-types'
import {PULLS_INBOX_PATH} from '../constants/routes'

type FetchSectionDeferredDataParams =
  | {
      query: string
    }
  | {
      prIds: ReadonlyArray<DeferredItem['id']>
    }

export function deferredPullRequestIdParam(id: DeferredItem['id']): ['ids[]' | 'pr_ids[]', string] {
  return [typeof id === 'string' ? 'ids[]' : 'pr_ids[]', String(id)]
}

export async function fetchSectionDeferredData(parameters: FetchSectionDeferredDataParams): Promise<DeferredItem[]> {
  // deferred endpoint responds to _either_ a query or a list of PR IDs
  const params = new URLSearchParams({page: '1'})

  if ('query' in parameters && parameters.query) {
    params.set('q', parameters.query)
  }

  if ('prIds' in parameters && parameters.prIds) {
    for (const prId of parameters.prIds) {
      const [name, value] = deferredPullRequestIdParam(prId)
      params.append(name, value)
    }
  }

  const response = await reactFetchJSON(`${PULLS_INBOX_PATH}/deferred?${params.toString()}`)
  if (!response.ok) {
    throw new Error(`Failed to fetch deferred data: ${response.statusText}`)
  }
  const json: PullsInboxDeferredDataPayload = await response.json()
  return json.payload.pullsInboxSurfaceContentDeferredData.results
}
